import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectInspectionPlanData = state => selectState(state).data;
export const selectInspectionPlanLoading = state => selectState(state).loading;
export const selectInspectionPlanError = state => selectState(state).error;
export const selectInspectionPlanFilterVisible = state => selectState(state).filterVisible;
export const selectInspectionPlanFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredInspectionPlans = createSelector(
  [selectInspectionPlanData, selectInspectionPlanFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);


